export default "__VITE_ASSET__DkBvYhuM__"